var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCorsiIscrizione(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M836.76,0H187.94C108.71,0,44.37,64.46,44.37,143.57v736.86c0,47.4,23.36,91.71,62.4,118.5,24.16,16.6,52.55,25.07,81.06,25.07,17.52,0,35.15-3.21,52.09-9.85l257.6-100.06c9.62-3.78,20.15-3.78,29.77,0l257.6,100.06c44.19,17.17,94,11.45,133.04-15.34,39.04-26.68,62.4-70.98,62.4-118.38V143.57C980.33,64.34,915.87,0,836.76,0ZM679.79,495.4h-111.51v111.4c0,28.28-22.9,51.29-51.18,51.29s-51.18-22.9-51.18-51.18v-111.51h-111.4c-28.28,0-51.18-22.9-51.18-51.18s22.9-51.18,51.18-51.18h111.4v-111.51c0-28.28,22.9-51.18,51.18-51.18s51.18,22.9,51.18,51.18v111.51h111.51c28.28,0,51.18,22.9,51.18,51.18s-22.9,51.18-51.18,51.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCorsiIscrizione);
export default __webpack_public_path__ + "static/media/menu-corsi-iscrizione.730d93abf0b215b7b68ab10937d1cedb.svg";
export { ForwardRef as ReactComponent };